// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
export var WebComponentUIContext;
(function (WebComponentUIContext) {
    WebComponentUIContext["WEB_COMPONENT_UI_CONTEXT_UNSPECIFIED"] = "WEB_COMPONENT_UI_CONTEXT_UNSPECIFIED";
    WebComponentUIContext["WEB_COMPONENT_UI_CONTEXT_ONBOARDING"] = "WEB_COMPONENT_UI_CONTEXT_ONBOARDING";
    WebComponentUIContext["WEB_COMPONENT_UI_CONTEXT_CHECKOUT_FORM"] = "WEB_COMPONENT_UI_CONTEXT_CHECKOUT_FORM";
    WebComponentUIContext["WEB_COMPONENT_UI_CONTEXT_DISPUTE_MANAGEMENT"] = "WEB_COMPONENT_UI_CONTEXT_DISPUTE_MANAGEMENT";
    WebComponentUIContext["WEB_COMPONENT_UI_CONTEXT_TOKENIZATION"] = "WEB_COMPONENT_UI_CONTEXT_TOKENIZATION";
})(WebComponentUIContext || (WebComponentUIContext = {}));
export var WebComponentUIContext_index;
(function (WebComponentUIContext_index) {
    WebComponentUIContext_index[WebComponentUIContext_index["WEB_COMPONENT_UI_CONTEXT_UNSPECIFIED"] = 0] = "WEB_COMPONENT_UI_CONTEXT_UNSPECIFIED";
    WebComponentUIContext_index[WebComponentUIContext_index["WEB_COMPONENT_UI_CONTEXT_ONBOARDING"] = 1] = "WEB_COMPONENT_UI_CONTEXT_ONBOARDING";
    WebComponentUIContext_index[WebComponentUIContext_index["WEB_COMPONENT_UI_CONTEXT_CHECKOUT_FORM"] = 2] = "WEB_COMPONENT_UI_CONTEXT_CHECKOUT_FORM";
    WebComponentUIContext_index[WebComponentUIContext_index["WEB_COMPONENT_UI_CONTEXT_DISPUTE_MANAGEMENT"] = 3] = "WEB_COMPONENT_UI_CONTEXT_DISPUTE_MANAGEMENT";
    WebComponentUIContext_index[WebComponentUIContext_index["WEB_COMPONENT_UI_CONTEXT_TOKENIZATION"] = 4] = "WEB_COMPONENT_UI_CONTEXT_TOKENIZATION";
})(WebComponentUIContext_index || (WebComponentUIContext_index = {}));
export var SubAccountType;
(function (SubAccountType) {
    SubAccountType["SUB_ACCOUNT_TYPE_UNSPECIFIED"] = "SUB_ACCOUNT_TYPE_UNSPECIFIED";
    SubAccountType["SUB_ACCOUNT_TYPE_LIVE"] = "SUB_ACCOUNT_TYPE_LIVE";
    SubAccountType["SUB_ACCOUNT_TYPE_TEST"] = "SUB_ACCOUNT_TYPE_TEST";
})(SubAccountType || (SubAccountType = {}));
export var SubAccountType_index;
(function (SubAccountType_index) {
    SubAccountType_index[SubAccountType_index["SUB_ACCOUNT_TYPE_UNSPECIFIED"] = 0] = "SUB_ACCOUNT_TYPE_UNSPECIFIED";
    SubAccountType_index[SubAccountType_index["SUB_ACCOUNT_TYPE_LIVE"] = 1] = "SUB_ACCOUNT_TYPE_LIVE";
    SubAccountType_index[SubAccountType_index["SUB_ACCOUNT_TYPE_TEST"] = 2] = "SUB_ACCOUNT_TYPE_TEST";
})(SubAccountType_index || (SubAccountType_index = {}));
export var RefundStatus;
(function (RefundStatus) {
    RefundStatus["REFUND_UNSPECIFIED"] = "REFUND_UNSPECIFIED";
    RefundStatus["REFUND_PENDING"] = "REFUND_PENDING";
    RefundStatus["REFUND_SUCCEEDED"] = "REFUND_SUCCEEDED";
    RefundStatus["REFUND_FAILED"] = "REFUND_FAILED";
})(RefundStatus || (RefundStatus = {}));
export var RefundStatus_index;
(function (RefundStatus_index) {
    RefundStatus_index[RefundStatus_index["REFUND_UNSPECIFIED"] = 0] = "REFUND_UNSPECIFIED";
    RefundStatus_index[RefundStatus_index["REFUND_PENDING"] = 1] = "REFUND_PENDING";
    RefundStatus_index[RefundStatus_index["REFUND_SUCCEEDED"] = 2] = "REFUND_SUCCEEDED";
    RefundStatus_index[RefundStatus_index["REFUND_FAILED"] = 3] = "REFUND_FAILED";
})(RefundStatus_index || (RefundStatus_index = {}));
export var RefundReason;
(function (RefundReason) {
    RefundReason["UNSPECIFIED"] = "UNSPECIFIED";
    RefundReason["DUPLICATE"] = "DUPLICATE";
    RefundReason["FRAUDULENT"] = "FRAUDULENT";
    RefundReason["CUSTOMER_REQUEST"] = "CUSTOMER_REQUEST";
})(RefundReason || (RefundReason = {}));
export var RefundReason_index;
(function (RefundReason_index) {
    RefundReason_index[RefundReason_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    RefundReason_index[RefundReason_index["DUPLICATE"] = 1] = "DUPLICATE";
    RefundReason_index[RefundReason_index["FRAUDULENT"] = 2] = "FRAUDULENT";
    RefundReason_index[RefundReason_index["CUSTOMER_REQUEST"] = 3] = "CUSTOMER_REQUEST";
})(RefundReason_index || (RefundReason_index = {}));
export var SubAccountStatus;
(function (SubAccountStatus) {
    SubAccountStatus["SUBACCOUNT_STATUS_UNSPECIFIED"] = "SUBACCOUNT_STATUS_UNSPECIFIED";
    SubAccountStatus["SUBACCOUNT_STATUS_CREATED"] = "SUBACCOUNT_STATUS_CREATED";
    SubAccountStatus["SUBACCOUNT_STATUS_SUBMITTED"] = "SUBACCOUNT_STATUS_SUBMITTED";
    SubAccountStatus["SUBACCOUNT_STATUS_INFORMATION_NEEDED"] = "SUBACCOUNT_STATUS_INFORMATION_NEEDED";
    SubAccountStatus["SUBACCOUNT_STATUS_REJECTED"] = "SUBACCOUNT_STATUS_REJECTED";
    SubAccountStatus["SUBACCOUNT_STATUS_ENABLED"] = "SUBACCOUNT_STATUS_ENABLED";
    SubAccountStatus["SUBACCOUNT_STATUS_DISABLED"] = "SUBACCOUNT_STATUS_DISABLED";
    SubAccountStatus["SUBACCOUNT_STATUS_ARCHIVED"] = "SUBACCOUNT_STATUS_ARCHIVED";
})(SubAccountStatus || (SubAccountStatus = {}));
export var SubAccountStatus_index;
(function (SubAccountStatus_index) {
    SubAccountStatus_index[SubAccountStatus_index["SUBACCOUNT_STATUS_UNSPECIFIED"] = 0] = "SUBACCOUNT_STATUS_UNSPECIFIED";
    SubAccountStatus_index[SubAccountStatus_index["SUBACCOUNT_STATUS_CREATED"] = 1] = "SUBACCOUNT_STATUS_CREATED";
    SubAccountStatus_index[SubAccountStatus_index["SUBACCOUNT_STATUS_SUBMITTED"] = 2] = "SUBACCOUNT_STATUS_SUBMITTED";
    SubAccountStatus_index[SubAccountStatus_index["SUBACCOUNT_STATUS_INFORMATION_NEEDED"] = 3] = "SUBACCOUNT_STATUS_INFORMATION_NEEDED";
    SubAccountStatus_index[SubAccountStatus_index["SUBACCOUNT_STATUS_REJECTED"] = 4] = "SUBACCOUNT_STATUS_REJECTED";
    SubAccountStatus_index[SubAccountStatus_index["SUBACCOUNT_STATUS_ENABLED"] = 5] = "SUBACCOUNT_STATUS_ENABLED";
    SubAccountStatus_index[SubAccountStatus_index["SUBACCOUNT_STATUS_DISABLED"] = 6] = "SUBACCOUNT_STATUS_DISABLED";
    SubAccountStatus_index[SubAccountStatus_index["SUBACCOUNT_STATUS_ARCHIVED"] = 7] = "SUBACCOUNT_STATUS_ARCHIVED";
})(SubAccountStatus_index || (SubAccountStatus_index = {}));
export var RegisterTerminalStatusResponse_Status;
(function (RegisterTerminalStatusResponse_Status) {
    RegisterTerminalStatusResponse_Status["TERMINAL_REGISTERED_STATUS_UNKNOWN"] = "TERMINAL_REGISTERED_STATUS_UNKNOWN";
    RegisterTerminalStatusResponse_Status["TERMINAL_REGISTERED_STATUS_SUCCEEDED"] = "TERMINAL_REGISTERED_STATUS_SUCCEEDED";
    RegisterTerminalStatusResponse_Status["TERMINAL_REGISTERED_STATUS_FAILED"] = "TERMINAL_REGISTERED_STATUS_FAILED";
})(RegisterTerminalStatusResponse_Status || (RegisterTerminalStatusResponse_Status = {}));
export var RegisterTerminalStatusResponse_Status_index;
(function (RegisterTerminalStatusResponse_Status_index) {
    RegisterTerminalStatusResponse_Status_index[RegisterTerminalStatusResponse_Status_index["TERMINAL_REGISTERED_STATUS_UNKNOWN"] = 0] = "TERMINAL_REGISTERED_STATUS_UNKNOWN";
    RegisterTerminalStatusResponse_Status_index[RegisterTerminalStatusResponse_Status_index["TERMINAL_REGISTERED_STATUS_SUCCEEDED"] = 1] = "TERMINAL_REGISTERED_STATUS_SUCCEEDED";
    RegisterTerminalStatusResponse_Status_index[RegisterTerminalStatusResponse_Status_index["TERMINAL_REGISTERED_STATUS_FAILED"] = 2] = "TERMINAL_REGISTERED_STATUS_FAILED";
})(RegisterTerminalStatusResponse_Status_index || (RegisterTerminalStatusResponse_Status_index = {}));
export const JustfiIntegration = {
    CreateWebComponentToken(fn, req) {
        return fn(`/payments-platform/justifi-integration/web-component-tokens`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetMerchantConnection(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/payments-platform/justifi-integration/merchant-connections/${req["locationId"]}?${fm.renderURLSearchParams(req, ["locationId"])}`, { method: "GET" });
    },
    CreateMerchantConnection(fn, req) {
        return fn(`/payments-platform/justifi-integration/merchant-connections`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    RefreshMerchantConnection(fn, req) {
        return fn(`/payments-platform/justifi-integration/merchant-connections/refresh`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    ListDisputes(fn, req) {
        return fn(`/payments-platform/justifi-integration/disputes`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    CompleteCheckout(fn, req) {
        return fn(`/payments-platform/justifi-integration/complete-checkout`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetBusiness(fn, req) {
        try {
            fm.validateUrlParam(req["businessId"], "businessId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/payments-platform/justifi-integration/business/${req["businessId"]}?${fm.renderURLSearchParams(req, ["businessId"])}`, { method: "GET" });
    },
    RegisterTerminal(fn, req) {
        return fn(`/payments-platform/justifi-integration/terminals:register`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    RegisterTerminalStatus(fn, req) {
        return fn(`/payments-platform/justifi-integration/terminals/register/status?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetSubAccountSettings(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/payments-platform/justifi-integration/sub-account-settings/${req["locationId"]}?${fm.renderURLSearchParams(req, ["locationId"])}`, { method: "GET" });
    },
};
